import React, { ReactNode } from "react";

interface BenefitCardProps {
  title: string;
  description: ReactNode;
  image: string;
}

const BenefitCard: React.FC<BenefitCardProps> = ({
  title,
  description,
  image,
}) => {
  return (
    <div className="dui-benefit-card">
      <h3 className="dui-benefit-card-title">{title}</h3>
      <div className="dui-benefit-card-image">
        <img src={image} alt={title} />
      </div>
      <p className="dui-benefit-card-description">{description}</p>
    </div>
  );
};

export default BenefitCard;
